import { useMemo, useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import PageTitle from "../XoSoCompound/PageTitle";
import LotteryDatePicker from "../XoSoCompound/LotteryDatePicker";
import VietlottResultCard from "./VietlottResultCard";
import useVietlottResults from "./useVietlottResults";
import { GAME_TITLES, resolveVietlottGames, TZ } from "./constants";
import "../XoSoCompound/XoSoCompound.css";
import "./VietlottCompound.css";

dayjs.extend(utc);
dayjs.extend(timezone);

function VietlottCompound({ title, showTitle = false, defaultDate, category, lotteryType, config }) {
  const games = useMemo(
    () => resolveVietlottGames(category ?? lotteryType ?? config?.lotteryType),
    [category, lotteryType, config?.lotteryType]
  );
  const today = dayjs().tz(TZ).format("YYYY-MM-DD");
  const [date, setDate] = useState(defaultDate || null);
  const { results, loading, resolvedDate } = useVietlottResults(date, games);
  const selectedDate = date || resolvedDate || today;
  const heading = title || GAME_TITLES[games.length === 1 ? games[0] : "all"];

  return (
    <div className="xoso-compound vietlott-compound">
      {showTitle ? <PageTitle>{heading}</PageTitle> : null}

      <div className="xoso-compound__layout">
        <aside className="xoso-compound__sidebar">
          <LotteryDatePicker value={selectedDate} onChange={setDate} maxDate={today} />
        </aside>

        <div className="xoso-compound__main">
          <div className={`vietlott-stack${loading ? " is-loading" : ""}`}>
            {loading ? <div className="vietlott-stack__spinner" /> : null}
            {!loading && !results.length ? (
              <div className="vietlott-card">
                <div className="xoso-kqxs__empty">
                  Không có dữ liệu ngày {dayjs(selectedDate).format("DD/MM/YYYY")}
                </div>
              </div>
            ) : null}
            {results.map((item) => (
              <VietlottResultCard key={item.id || `${item.game}-${item.drawId}`} result={item} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

VietlottCompound.PageTitle = PageTitle;
VietlottCompound.DatePicker = LotteryDatePicker;
VietlottCompound.ResultCard = VietlottResultCard;

export { PageTitle, LotteryDatePicker, VietlottResultCard };
export default VietlottCompound;
